export const headers: Record<string, string[]> = {
  META: [
    "stockNumber",
    "vin",
    "dateTime",
    "providerId",
    "accountId",
    "sourceId",
    "active",
    "skipVehicle",
    "status",
    "type",
    "classification",
    "certified"
  ],
  DESCRIPTION: [
    "modelCode",
    "year",
    "make",
    "model",
    "trim",
    "bodyStyle",
    "doors"
  ],
  POWERTRAIN: ["driveline", "transmission", "engine", "engineSize"],
  DIMENSIONS: ["wheelbase", "cab", "bed"],
  FUEL: ["fuel", "cityMpg", "highwayMpg"],
  MILEAGE: ["mileage"],
  PRICING: [
    "retailValue",
    "invoicePrice",
    "askingPrice",
    "wholesalePrice",
    "msrp",
    "salePrice",
    "eleadPrice",
    "eleadPriceLessOemCash",
    "dealerFee",
    "discount",
    "actualCashValue",
    "salesCost",
    "kbbValue"
  ],
  "COMMENTS & OPTIONS": ["comments", "options", "optionCodes", "packageCodes"],
  COLOR: ["extColor", "extColorCode", "intColor", "intColorCode"],
  MEDIA: [
    "image",
    "imageDate",
    "imageDateTimeZone",
    "imagesModified",
    "videoId",
    "externalImagesLastModifiedDate"
  ],
  WARRANTY: ["warrantyDescription"],
  "ADDITIONAL INFO": [
    "productionNum",
    "code",
    "accessories",
    "features",
    "vehiclePayload",
    "auxOptionData"
  ],
  DATES: ["lotDate"],
  "AUTONATION FIELDS": [
    "autonationCustomerCash",
    "autonationAccessories",
    "autonationMsrpAdv",
    "autonationMsrpBeforePkgDisc",
    "autonationPkgDisc"
  ],
  "CUSTOM PRICE": [
    "customPrice01",
    "customPrice02",
    "customPrice03",
    "customPrice04",
    "customPrice05",
    "customPrice06",
    "customPrice07",
    "customPrice08",
    "customPrice09",
    "customPrice10",
    "customPrice11",
    "customPrice12",
    "customPrice13",
    "customPrice14",
    "customPrice15",
    "customPrice16",
    "customPrice17",
    "customPrice18",
    "customPrice19",
    "customPrice20"
  ],
  MISC: [
    "misc01",
    "misc02",
    "misc03",
    "misc04",
    "misc05",
    "misc06",
    "misc07",
    "misc08",
    "misc09",
    "misc10",
    "misc11",
    "misc12",
    "misc13",
    "misc14",
    "misc15",
    "misc16",
    "misc17",
    "misc18",
    "misc19",
    "misc20"
  ]
};

export const getHeadersForCategory = (category: string) => {
  return headers[category];
};

export const allHeaderKeys = Object.values(headers).flat();

export const allHeaderCategories: string[] = Object.keys(headers);

export const defaultHeaderCategories = ["META", "DESCRIPTION"];

export const headerOrder = [
  "META",
  "DESCRIPTION",
  "DATES",
  "FUEL",
  "MILEAGE",
  "PRICING",
  "CUSTOM PRICE",
  "COLOR",
  "WARRANTY",
  "PRICING",
  "DIMENSIONS",
  "MEDIA",
  "DATES",
  "POWERTRAIN",
  "MISC",
  "CUSTOM PRICE",
  "AUTONATION FIELDS",
  "ADDITIONAL INFO",
  "COMMENTS & OPTIONS"
];
